import React, { Component } from 'react';
import PropTypes from "prop-types";
import moment from "moment";



class DateCellRender extends Component {

  render() {
    return this.props.value != null && this.props.value != "" ?  moment(this.props.value).format('MM/DD/YYYY') : "";
  }
}

DateCellRender.propTypes = {
  value: PropTypes.any,
};

export default DateCellRender;